const styles = {
  iconButton: (theme) => ({
    padding: 1,
    color: theme.palette.grey.L10,
    '&:hover': {
      backgroundColor: theme.palette.primary.L50,
    },
  }),
  menuItem: {
    padding: 2,
    '&:hover': {
      backgroundColor: 'primary.L90',
    },
  },
  menuItemIcon: {
    width: 24,
    height: 24,
    marginRight: 2,
    color: 'grey.L10',
  },
  menuPaper: {
    overflow: 'visible',
    mt: 2,
  },
  menuTriggerContainer: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    alignSelf: 'flex-end',
  },
  menuTriggerButton: { width: 24, height: 24 },
};

export default styles;
